/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './antibiotic.reducer';

export const AntibioticDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const antibioticEntity = useAppSelector(state => state.antibiotic.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="antibioticDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.antibiotic.detail.title">Antibiotic</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.antibiotic.id">Id</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.antibiotic.name">Name</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.name}</dd>
          <dt>
            <span id="tmClass">
              <Translate contentKey="tinyMedicRestApp.antibiotic.tmClass">Tm Class</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.tmClass}</dd>
          <dt>
            <span id="resistanceMechanisms">
              <Translate contentKey="tinyMedicRestApp.antibiotic.resistanceMechanisms">Resistance Mechanisms</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.resistanceMechanisms}</dd>
          <dt>
            <span id="notes">
              <Translate contentKey="tinyMedicRestApp.antibiotic.notes">Notes</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.notes}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.antibiotic.active">Active</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.antibiotic.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.antibiotic.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.antibiotic.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.antibiotic.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{antibioticEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.antibiotic.mechanismOfAction">Mechanism Of Action</Translate>
          </dt>
          <dd>{antibioticEntity.mechanismOfAction ? antibioticEntity.mechanismOfAction.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.antibiotic.spectrum">Spectrum</Translate>
          </dt>
          <dd>{antibioticEntity.spectrum ? antibioticEntity.spectrum.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/antibiotic" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/antibiotic/${antibioticEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AntibioticDetail;
